import { useState } from 'react';

import { useTooltip } from '../../components/Tooltip/useTooltip';
import { useHiddenBodyOverflow } from '../../hooks/useHiddenBodyOverflow';
import { useStores } from '../../stores/useStores';

import { ONBOARDING_CONFIG } from './constants';

type Params = Parameters<typeof useTooltip>;

export function useOnboarding(steps: Set<number>, placement: Params[0], offset: Params[1]) {
  const { onboardingStore } = useStores();

  const active = steps.has(onboardingStore.step);

  const [showOnboarding, setShowOnboarding] = useState(false);

  useHiddenBodyOverflow(showOnboarding);

  const { tooltipStyles, setReferenceElement: setRef, setPopperElement } = useTooltip(placement, offset);

  const setReferenceElement = (element: HTMLElement | null) => {
    if (active) {
      setRef(element);
      setTimeout(() => setShowOnboarding(true), ONBOARDING_CONFIG.ANIMATION_DELAY);
    }
  };

  return {
    showOnboarding: showOnboarding && active,
    tooltipStyles,
    setReferenceElement,
    setPopperElement,
  };
}
